import { GyroscopePlugin } from "@photo-sphere-viewer/gyroscope-plugin";
import { CompassPlugin } from "@photo-sphere-viewer/compass-plugin";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { GalleryPlugin } from "@photo-sphere-viewer/gallery-plugin";

export const viewerConfig = {
  navbar: ["zoom", "move", "caption", "fullscreen", "gallery", "gyroscope"],
  defaultZoomLvl: 0,
  mousewheel: true,
  size: {
    width: "100%",
    height: "100%"
  },
  loadingTxt: "Carregando imagem...",
  plugins: [
    [GyroscopePlugin, { touchmove: true }],
    [CompassPlugin, { size: "80px" }],
    [MarkersPlugin],
    [
      GalleryPlugin,
      {
        visibleOnLoad: false
      }
    ]
  ]
};
